import EditBlogTermsModal from './EditBlogTermsModal';

const EditBlogTagsModal = ({ modalDetails }) => (
  <EditBlogTermsModal modalDetails={modalDetails} kind="tags" />
);

export default EditBlogTagsModal;
